import { JobApplicationStepKey } from "../types/JobApplicationStepKey";
import { mapJobApplicationStepKey } from "./mapJobApplicationStepKey";

export const maxJobApplicationStepKey = (
  step1?: JobApplicationStepKey | null,
  step2?: JobApplicationStepKey | null,
): JobApplicationStepKey | null | undefined => {
  if (step1 && step2) {
    return mapJobApplicationStepKey[step1] >= mapJobApplicationStepKey[step2] ? step1 : step2;
  }

  if (step1) {
    return step1;
  } else {
    return step2;
  }
};
